export default class SwScrollTo extends ContaoWebpack.Plugin {
  init() {
    this.options = {
      ...{
        element: null,
        offsetTop: 0,
        visisbleAfter: 0,
      },
      ...this.options,
    };

    if (this.options.element === null) {
      return;
    }

    this.jumpElement = document.querySelector(this.options.element);

    if (this.jumpElement === null || this.jumpElement === undefined) {
      return;
    }

    this.el.addEventListener("click", () => {
      window.scroll({
        left: 0,
        behavior: "smooth",
        top: this.jumpElement.offsetTop - this.options.offsetTop,
      });
    });

    if (this.options.visisbleAfter > 0) {
      this.setupVisibility();
      document.addEventListener("scroll", () => {
        this.setupVisibility();
      });
    } else {
      this.el.classList.add("sw-scroll-to-visible");
    }
  }

  setupVisibility() {
    if (window.scrollY >= this.options.visisbleAfter) {
      if (!this.el.classList.contains("sw-scroll-to-visible")) {
        this.el.classList.add("sw-scroll-to-visible");
      }
    } else {
      if (this.el.classList.contains("sw-scroll-to-visible")) {
        this.el.classList.remove("sw-scroll-to-visible");
      }
    }
  }
}
